import { LazyLoader } from "@CodeDaleTheme/lazy-load";

class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  initData() {
    // Read the persisted list of recently-viewed product ids (may be null).
    const storedProductIds = JSON.parse(
      localStorage.getItem("recently-viewed-products")
    );
    this.getStoredProducts(storedProductIds);
  }
  getStoredProducts(productIds) {
    const limit = this.dataset?.limit;
    // Build the `&q=id:...` filter from the stored ids, capped at the configured limit.
    // NOTE: productAjaxURL uses `var` so it stays visible to the fetch call below the block.
    if (limit) {
      let query = "";
      var productAjaxURL = "";
      if (productIds && productIds.length > 0) {
        const productIdsCopy = productIds.slice();
        const limitedIds = productIdsCopy.slice(0, limit);
        query = limitedIds.join("%20OR%20id:");
        productAjaxURL = `&q=id:${query}`;
      }
    }
    fetch(`${this.dataset.url}${productAjaxURL}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recentlyViewedProducts = html.querySelector(
          "recently-viewed-products"
        );
        if (
          recentlyViewedProducts &&
          recentlyViewedProducts.innerHTML.trim().length
        ) {
          this.innerHTML = recentlyViewedProducts.innerHTML;
        }
        new LazyLoader(".image-lazy-load");
      })
      .finally(() => {})
      .catch((e) => {
        console.error(e);
      });
  }
  connectedCallback() {
    const element = this;
    // Defer fetching products until the element scrolls near the viewport.
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      element.initData();
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 100px 0px",
    }).observe(this);
  }
}
customElements.define("recently-viewed-products", RecentlyViewedProducts);